import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@store/baseQueries";
import { userBaseUrl } from "@store/urlPaths";
import {
  changePassword,
  forgotPassword,
  loginUser,
  logoutUser,
  resetPassword,
} from "./queries";
import { message } from "antd";
import { getErrorMessage } from "@utils/error";

const userApi = createApi({
  reducerPath: "user",
  baseQuery: baseQuery(userBaseUrl),
  endpoints: (builder) => ({
    // login user
    loginUser: builder.mutation({
      query: loginUser,
      async onQueryStarted(arg, { queryFulfilled }) {
        const { navigate } = arg;
        try {
          const { data } = await queryFulfilled;
          if (data.success) {
            const { accessToken, user_details } = data;
            if (!user_details.isActive) {
              message.error(
                `Hello, ${user_details.firstName}!, Your account is in active. Please contact your admin`
              );
              return;
            }
            const newUser = {
              accessToken,
              user: user_details,
              loginTime: Date.now(),
            };
            localStorage.setItem("c2p", JSON.stringify(newUser));
            message.success(
              `Hello, ${user_details.firstName}! Welcome to the Market Intelligence App `
            );
            navigate("/", { replace: true });
          }
        } catch (err) {
          message.error(getErrorMessage(err, "Login failed!"));
        }
      },
    }),
    // logout user
    logoutUser: builder.mutation({
      query: logoutUser,
      async onQueryStarted(arg, { queryFulfilled }) {
        const { navigate } = arg;
        try {
          const { data } = await queryFulfilled;
          if (data.success) {
            localStorage.clear();
            navigate("/login");
            message.success(data.message);
          }
        } catch (err) {
          message.error(getErrorMessage(err, "Logout failed!"));
        }
      },
    }),
    // forgot password
    sendPasswordResetLink: builder.mutation({
      query: forgotPassword,
      async onQueryStarted(arg, { queryFulfilled }) {
        const { navigate } = arg;
        try {
          const { data } = await queryFulfilled;
          if (data.success) {
            message.success(data.message);
            navigate("/login");
          }
        } catch (err) {
          message.error(
            getErrorMessage(err, "Send password reset link failed!")
          );
        }
      },
    }),
    // reset password
    resetPassword: builder.mutation({
      query: resetPassword,
      async onQueryStarted(arg, { queryFulfilled }) {
        const { navigate } = arg;
        try {
          const { data } = await queryFulfilled;
          if (data.success) {
            message.success(data.message);
            navigate("/login");
          }
        } catch (err) {
          message.error(getErrorMessage(err, "Reset password failed!"));
        }
      },
    }),
    // change password
    changePassword: builder.mutation({
      query: changePassword,
    }),
  }),
});

export const {
  useLoginUserMutation,
  useLogoutUserMutation,
  useSendPasswordResetLinkMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
  reducer: userReducer,
  reducerPath: userReducerPath,
  middleware: userMiddleware,
} = userApi;
